import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconParagraphStyle0 = gravityIconIndividualCss;

const GravityIconParagraph = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '44afa73d1080ae05c603a643ebb429885a5b139d', color: this.color, size: this.size }, h("svg", { key: '4fe31566e5d3c72b672855a417b9786c7ea3ef04', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '30a929823da9879e14a43f14140ae7323c4bfb64', d: "M10 11a4 4 0 1 1 0-8h4.5a.5.5 0 0 1 .5.5v14a.5.5 0 0 1-.5.5H14a.5.5 0 0 1-.5-.5v-13H12v13a.5.5 0 0 1-.5.5H11a.5.5 0 0 1-.5-.5V11H10Z", fill: "currentColor" }))));
    }
};
GravityIconParagraph.style = GravityIconParagraphStyle0;

export { GravityIconParagraph as gravity_icon_paragraph };

//# sourceMappingURL=gravity-icon-paragraph.entry.js.map